export const getPublicUrl = (i18n) => {
  try {
    var split = process.env.PUBLIC_URL.split("/");
    let result = split[0];

    if (i18n.language !== "uk") {
      result += "/" + i18n.language;
    }

    for (let i = 1; i < split.length; i++) {
      result += "/" + split[i];
    }

    return result;
  } catch (e) {
    (console.error || console.log).call(console, e.stack || e);
    return process.env.PUBLIC_URL;
  }
};

export const getUrlQuery = (obj) => {
  try {
    const {
      date,
      printWidth,
      printHeight,
      style,
      centerLat,
      centerLon,
      mapWidth,
      mapHeight,
      containerWidth,
      containerHeight,
      background,
      stroke,
      isGridEnabled,
      isConstellationsEnabled,
      isMWEnabled,
      isNamesEnabled,
      language,
    } = obj;

    let query = "?";
    query += `centerLat=${centerLat}&centerLon=${centerLon}&date=${date}&mapWidth=${mapWidth}&mapHeight=${mapHeight}&containerWidth=${containerWidth}&containerHeight=${containerHeight}&background=${encodeURIComponent(
      background
    )}&stroke=${encodeURIComponent(
      stroke
    )}&isGridEnabled=${isGridEnabled}&isConstellationsEnabled=${isConstellationsEnabled}&isMWEnabled=${isMWEnabled}&isNamesEnabled=${isNamesEnabled}&language=${language}&printWidth=${printWidth}&printHeight=${printHeight}&style=${style}`;
    return query;
  } catch (e) {
    (console.error || console.log).call(console, e.stack || e);
    return null;
  }
};

export const getAllStyles = (isTest) => {
  let styles = [
    {
      id: "simple_white",
      name: "white",
    },
    {
      id: "simple_black",
      name: "black",
    },
    {
      id: "peak",
      name: "peak",
    },
    {
      id: "simple_white_overlay_couple",
      name: "couple",
    },
  ];

  if (isTest) {
    styles.push({
      id: "simple_white_clip_heart",
      name: "white heart",
    });
    styles.push({
      id: "simple_black_clip_heart",
      name: "black heart",
    });
  }
  return styles;
};
export const getStyleSettingsByStyleId = (styleId) => {
  try {
    let background = "";
    let stroke = "";

    switch (styleId) {
      case "simple_black":
        background = "#000000";
        stroke = "#ffffff";

        break;
      case "simple_white":
        background = "#000000";
        stroke = "#000000";

        break;

      case "peak":
        background = "#09242E";
        stroke = "#ffffff";
        break;
      case "simple_white_overlay_couple":
        background = "#000000";
        stroke = "#000000";

        break;
      case "simple_white_clip_heart":
        background = "#000000";
        stroke = "#000000";

        break;
      case "simple_black_clip_heart":
        background = "#000000";
        stroke = "#ffffff";

        break;
      default:
        throw "Не могу найти стиль: " + styleId;
    }
    return {
      background,
      stroke,
    };
  } catch (e) {
    (console.error || console.log).call(console, e.stack || e);
  }
};
